<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hindi-accordion-toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      const content = this.closest(".hindi-content-accordion").querySelector(".hindi-accordion-content");
      const isVisible = content.style.display === "block";
      content.style.display = isVisible ? "none" : "block";
      toggle.classList.toggle("active");
    });
  });
});

 document.addEventListener("DOMContentLoaded", function () {
    if (window.location.href.toLowerCase().includes("sample")) {
      var exclusivePrices = document.querySelectorAll(".max-exclusive-price");
      exclusivePrices.forEach(function(el) {
        el.style.display = "none";
      });
    }
  });

